module.exports = __webpack_public_path__ + "static/media/b2_p2_clickable.a97efaa9.png";